import { render } from "./IntegrationOrderCard.vue?vue&type=template&id=f5af693e"
import script from "./IntegrationOrderCard.vue?vue&type=script&lang=js"
export * from "./IntegrationOrderCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__